import GalleryIcon from "src/assets/all-icons/gallery-icon.jsx";
import UserIcon from "src/assets/all-icons/user-icon.jsx";

import ArtistIcon from '@/assets/all-icons/artist-icon';
import config from '@/config';
import ImageUpdateLoader from '@/shared-components/loader/special-loaders/ImageUpdateLoader';

import './styles/UserProfileImage.css';

export default function UserProfileImage({ image, typeOfProfile, loading = false, className, onClick = null, style = {} }) {  
  if (loading) {
    return (
      <div className={`user-profile-image-loading-generic${typeOfProfile === "gallery" ? " gallery" : ""} ${className}`} onClick={onClick} style={style}>
        <ImageUpdateLoader className="user-profile-image-loading-generic__spinner" />
      </div>
    );
  } else if (!image) {
    return (
      <div className={`user-profile-no-image-generic${typeOfProfile === "gallery" ? " gallery" : ""} ${className}`} onClick={onClick} style={style}>
        {typeOfProfile === "gallery" ? 
          <GalleryIcon className="user-profile-no-image-generic__icon" /> :
          typeOfProfile === "artist" ? 
            <ArtistIcon className="user-profile-no-image-generic__icon artist" /> :
            <UserIcon className="user-profile-no-image-generic__icon user" />
        }
      </div>
    );
  } else {
    return (
      <img 
        src={`${config.app.imageServiceDomain}/${image}/w=200`} 
        alt="user profile pic" 
        loading="lazy" 
        className={`user-profile-image-generic${typeOfProfile === "gallery" ? " gallery" : ""} ${className}`} 
        onClick={onClick}
        style={style}
      />
    );
  }
}
